import React, { ReactElement } from 'react';
import { useTransition, animated } from 'react-spring';

interface DrawerProps {
  children: ReactElement;
  className?: string;
  open: Boolean;
}

export default function Drawer({
  children,
  className = '',
  open = false,
}: DrawerProps): ReactElement {
  const transitions = useTransition(open, null, {
    from: { left: '-100%' },
    enter: { left: '0%' },
    leave: { left: '-100%' },
  });

  return transitions.map(
    ({ item, key, props }: any) =>
      item && (
        <animated.div key={key} className={className} style={props}>
          {children}
        </animated.div>
      ),
  );
}
